import { Box, Stack, Typography } from '@mui/material'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { CardVariant, COLORS, unit } from '@hcr/ui'

import { useOwnersQuery } from '../../../../hooks'
import { createOwnersContent } from '../../../../utils'
import { Background, LayoutNavigation, LayoutNavigationError500, Metadata } from '../../../common'

import { OwnerUncontractedLoading } from './OwnerUncontractedLoading'

const ownersContent = createOwnersContent({
  slidesMargin: unit(3),
  variant: CardVariant.Owner,
})

export const OwnerUncontracted: FC = () => {
  const owners = useOwnersQuery({ isContracted: false })
  const { t } = useTranslation()

  if (owners.isError) {
    return <LayoutNavigationError500 />
  }

  if (owners.isSuccess) {
    return (
      <LayoutNavigation>
        <Metadata title={t('page-title.owner')} />
        <Box paddingX={unit(3)} bgcolor={COLORS.white}>
          <Box position='relative'>
            <Box position='absolute' sx={{ inset: 0 }}>
              <Background sx={{ height: unit(89) }} url={owners.data.imageUrl} />
            </Box>
            <Stack position='relative' zIndex={1} paddingTop={unit(69.25)}>
              <Stack
                direction='column'
                gap={unit(4)}
                paddingTop={unit(6.5)}
                paddingRight={unit(8)}
                paddingBottom={unit(7.5)}
                paddingLeft={unit(5.5)}
                bgcolor={COLORS.vaalea['60%']}
              >
                <Typography component='h1' variant='displayM' color={COLORS.red.dark}>
                  {owners.data.title}
                </Typography>
                <Typography component='h2' variant='bodyM'>
                  {owners.data.description}
                </Typography>
              </Stack>
            </Stack>
          </Box>
          <Stack gap={unit(3)} paddingY={unit(3)}>
            {owners.data.content.map(ownersContent)}
          </Stack>
        </Box>
      </LayoutNavigation>
    )
  }

  return <OwnerUncontractedLoading />
}
